











































import { Vue, Component, Prop } from 'vue-property-decorator';
import { List } from 'vant';
import { fetchNewslist } from '@/api/api';

Vue.use(List);

@Component
export default class News extends Vue {
  @Prop() classid!: any;

  newsList: any[] = [];
  loading = false;
  finished = false;
  page = 1;
  error = false;

  created() {
    this.getNewsList();
  }
  async getNewsList() {
    this.loading = true;
    try {
      const ret: any = await fetchNewslist(this.page, this.classid);
      this.loading = false;
      if (!ret.data.length) {
        this.finished = true;
      } else {
        this.newsList = [...this.newsList, ...ret.data];
        this.page++;
      }
    } catch (err) {
      console.log('异常报告', err);
      this.error = true;
    }
  }
  resetNewsList() {
    this.finished = false;
    this.newsList = [];
    this.page = 1;
  }
  onJumpToDetail(newsItem: any) {
    if (window.isSYWebview) {
      const { id, classId, dataType } = newsItem;
      if (Number(dataType) === 7) {
        location.href = newsItem.targetUrl;
        return;
      } else {
        const option = {
          dt: dataType,
          cid: classId,
          nid: id,
        };
        window.handleMessage(
          JSON.stringify({
            action: 'mJump',
            data: JSON.stringify(option),
          }),
        );
      }
    } else {
      location.href = newsItem.targetUrl;
    }
  }
}
